import React, {Component} from "react";
import ReactDOM from "react-dom";
import Overlay from '../../components/Overlay'
import { Helmet } from 'react-helmet'
import { compose, lifecycle } from 'recompose'
import { injectIntl } from 'react-intl'

export const Dr = () => {
  let self = this
  let content = `
	<div style="padding-top:16px; padding-left:25px; padding-right:25px; position:relative; z-index:3; font-family:Arial; color:#ff5027; ">
        <img class="modal_dr_0" src="https://landingmfc.dev-vt2b.ru/assets/img/logoBirthday.jpg" alt="" />
        <div class="modal_dr_1" >8 июля, 17:00 (GMT+3)</div>
        <div class="modal_dr_2" >Дорогие друзья!</div>
        <div class="modal_dr_3" >Рад пригласить вас на свой день рождения.
        <br />
        <br />В этом году, благодаря zoom-формату
        <br />жду друзей от Владивостока до
        <br />Лос-Анджелеса присоединиться
        <br />и поднять вместе бокал.</div>
        <div class="modal_dr_4" >Специальный гость: 
        <strong>Семён Слепаков.</strong></div>
        <div class="modal_dr_5">В качестве подарка, буду рад
        <br />поддержать фонд Meet For Charity
        <br />
        <a href="https://meetforcharity.today/mechetin" style="color:#000000" target="_blank">meetforcharity.today/mechetin</a>
        <br /></div>
        <div class="modal_dr_6">
          <strong>Александр Мечетин</strong>
        </div>
        <a href="https://us02web.zoom.us/j/89561862823?pwd=MjdXUFZubjhVamhlVEd6ZGtrRUJHUT09">
          <img src="https://landingmfc.dev-vt2b.ru/assets/img/kamera.jpg" alt="" class="modal_dr_8" />
          <div class="modal_dr_7" >Идентификатор: 895 6186 2823
          <br />Пароль: 966179</div>
        </a>
    </div>
`
  
  return (
  <div className='Container Container_light'>
  <div className='Donate'>
    <Helmet>
      <title>Приглашение на день рождения</title>
    </Helmet>
  
  <Overlay isActive={true} klassModifier={"mfc-modal_2"}>

	<div dangerouslySetInnerHTML={{__html: content}} />	

  </Overlay>
	
  </div>
  </div>
)
}

export default injectIntl(compose(
)(Dr))


// WEBPACK FOOTER //
// ./src/containers/Donate/Dr.jsx